import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  YAxis,
} from "recharts";
import {
  Typography,
  Box,
  IconButton,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import axios from "../../../api/axios";

// Full list of month abbreviations
const monthLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const BarChartComponent = ({ userId, userName }) => {
  const [dataByYear, setDataByYear] = useState({});
  const [selectedYear, setSelectedYear] = useState("");
  // const [showNext, setShowNext] = useState(false);
  const [showNext, setShowNext] = useState(new Date().getMonth() >= 6);

  useEffect(() => {
    const fetchData = async () => {
    if (userName === "KIMS_Trivandrum") {
    const kimsUtility = {
      "2024-25": [
          { month: "Apr", energy: 1206428, water: 14330 }, { month: "May", energy: 1208880, water: 14060 },
          { month: "Jun", energy: 1140806, water: 11262 }, { month: "Jul", energy: 1146190, water: 12361 },
          { month: "Aug", energy: 1183066, water: 15911 }, { month: "Sep", energy: 1138414, water: 12325 },
          { month: "Oct", energy: 1164006, water: 13499 }, { month: "Nov", energy: 1148286, water: 11977 },
          { month: "Dec", energy: 1110191, water: 11760 }, { month: "Jan", energy: 1129322, water: 16839 },
          { month: "Feb", energy: 1037282, water: 11881 }, { month: "Mar", energy: 1183774, water: 11991 }
      ]
    };
    setDataByYear(kimsUtility);
    setSelectedYear("2024-25");
    return;
  }
      try {
        const res = await axios.get(`/api/monthly-energy-water/${userId}`);
        console.log("barchart response user:", res);
        const yearData = res.data.data || {};
        setDataByYear(yearData);
        console.log(yearData);
        const years = Object.keys(yearData).sort();
        // if (years.length > 0) {
        //   setSelectedYear(years[years.length - 1]);
        // }
        const currentYear = String(new Date().getFullYear());
        if (years.length > 0) {
          setSelectedYear(
            years.includes(currentYear) ? currentYear : years[years.length - 1],
          );
        }
      } catch (err) {
        console.error("Error fetching chart data:", err);
      }
    };

    fetchData();
  }, [userId, userName]);

  const currentYearData = dataByYear[selectedYear] || [];

  const dataMap = Object.fromEntries(
    currentYearData.map((entry) => {
      const [month] = entry.month.split("-");
      return [month, { energy: entry.energy, water: entry.water }];
    }),
  );

  const fullData = monthLabels.map((month) => ({
    month,
    energy: dataMap[month]?.energy || 0,
    water: dataMap[month]?.water || 0,
  }));

  const visibleData = showNext ? fullData.slice(6) : fullData.slice(0, 6);

  return (
    <Box sx={{ width: "100%", textAlign: "left", position: "relative" }}>
      {/* Header and Year Selector */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="h6" color="green">
          Monthly Energy & Water Consumption
        </Typography>

        <FormControl size="small">
          <Select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            displayEmpty
            sx={{ bgcolor: "white", borderRadius: 1 }}
          >
            {Object.keys(dataByYear)
              .sort()
              .map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={250} padding="10px">
        <BarChart data={visibleData}>
          <CartesianGrid vertical={false} strokeDasharray="3 3" />

          <XAxis
            dataKey="month"
            tickLine={false}
            tickMargin={10}
            axisLine={false}
          />

          {/* Hide Y-axes for cleaner UI */}
          <YAxis yAxisId="left" orientation="left" hide />
          <YAxis yAxisId="right" orientation="right" hide />

          <Tooltip
           formatter={(value, name) =>
    name === "energy"
      ? [`Energy: ${value.toLocaleString()} kWh`]
      : [`Water: ${value.toLocaleString()} KL`]
  }
          />

          <Bar
            yAxisId="left"
            dataKey="energy"
            fill="#125427"
            radius={4}
            name="energy"
          />

          <Bar
            yAxisId="right"
            dataKey="water"
            fill="#16a34a"
            radius={4}
            name="water"
          />
        </BarChart>
      </ResponsiveContainer>

      {/* Arrows */}
      <IconButton
        sx={{ position: "absolute", left: 4, top: "50%" }}
        onClick={() => setShowNext(false)}
        disabled={!showNext}
      >
        <ArrowBack />
      </IconButton>

      <IconButton
        sx={{ position: "absolute", right: 4, top: "50%" }}
        onClick={() => setShowNext(true)}
        disabled={showNext}
      >
        <ArrowForward />
      </IconButton>
    </Box>
  );
};

export default BarChartComponent;
